var _Defs, _Use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, LinearGradient, Stop, Symbol as _Symbol, Path, Use } from "react-native-svg";
function SvgCloudy(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "cloudy_svg__a",
    x1: 99.45,
    y1: 30.68,
    x2: 232.64,
    y2: 261.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#deeafb"
  })), /*#__PURE__*/React.createElement(_Symbol, {
    id: "cloudy_svg__b",
    viewBox: "0 0 350 222"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M291 107c-.85 0-1.68.09-2.53.13A83.9 83.9 0 00135.6 42.92 55.91 55.91 0 0051 91a56.56 56.56 0 00.8 9.08A60 60 0 0063 219c1.35 0 2.67-.11 4-.2v.2h224a56 56 0 000-112z",
    stroke: "#959aa2",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    fill: "url(#cloudy_svg__a)"
  })))), _Use || (_Use = /*#__PURE__*/React.createElement(Use, {
    width: 350,
    height: 222,
    transform: "translate(81 145)",
    xlinkHref: "#cloudy_svg__b"
  })));
}
export default SvgCloudy;